export default __webpack_public_path__ + "img/fef4fa23c9f0060b911dcbba821c606b.svg";